import React from "react";
import PropTypes from "prop-types";

import Text from "components/Text";
import Container from "components/Container";
import Button from "components/Button";
import Link from "components/Link";
import Block from "components/Block";

import Sentry from "utils/sentry";
import "./style.scss";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      hasError: false,
      eventId: null,
      showStack: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.log("Caught error", error, errorInfo);

    const eventId = Sentry.lastEventId() ?? null;

    this.setState({ eventId });
  }

  render() {
    const { error, eventId, showStack } = this.state;

    // No error, render children
    if (error === null) {
      return this.props.children;
    }

    return (
      <Container>
        <div className="errorBoundary">
          <a href="/">&laquo; Back to homepage</a>

          <Text size="h2" weight="bold" className="mt-4">Crash</Text>
          <Text className="mb-2">Something went horribly wrong and it's not your fault.</Text>
          
          {eventId &&
            <Block className="mt-4">
              <Text className="mb-4">If you want to report this include the code below:</Text>
              <code style={{ padding: "10px" }}>{eventId}</code>
            </Block>
          }

          {showStack === false &&
            <Button
              style="ghost"
              size="small"
              className="mt-2"
              onClick={() => this.setState({ showStack: true })}
            >
              Show more info
            </Button>
          }

          {showStack === true &&
            <div className="errorBoundary__stack">
              <Text weight="bold" className="mb-2">Error details</Text>
              <blockquote><code>{error.message}</code></blockquote><br/>
              <blockquote><code>{error.stack}</code></blockquote>
            </div>
          }
        </div>
      </Container>
    );
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
};

ErrorBoundary.defaultProps = {
  children: null,
};

export default ErrorBoundary;

